import React from 'react';
import Button from '../common/Button';
import './loginStyle.css';

const SessionErrorModal = ({ onAccept, eviewMode = false }) => {
  const modalClass = `login-modal ${eviewMode ? 'eview-mode' : ''}`;

  return (
    <div className={modalClass}>
      <p className="login-modal__title">Server Error</p>
      <p className="login-modal__text">
        An error occurred while attempting to login to the server. Please try again.
      </p>
      <p className="login-modal__text login-modal__text--emphasis">
        If this problem persists, please contact Dividia at 866-348-4342.
      </p>
      <div className="login-modal__buttons">
        <Button onClick={onAccept} buttonText="OK" />
      </div>
    </div>
  );
};

export default SessionErrorModal;